var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumb',{staticClass:"p-mb-3",attrs:{"home":_vm.home,"model":_vm.breadcrumbItems}}),(_vm.moduleName)?_c('generic-datatable',{attrs:{"moduleName":_vm.moduleName,"moduleLabel":_vm.moduleLabel}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }